import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
interface CountdownProps {
  compact?: boolean;
}
export function Countdown({
  compact = false
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const units: Array<[string, string]> = [[pad(hours), 'ORE'], [pad(minutes), 'MIN'], [pad(seconds), 'SEC']];
  return <div className={compact ? '' : 'text-center'} data-id="element-16" data-mp="374meadei5t9p">
      <p className="text-[11px] font-black uppercase tracking-[0.2em] text-alert-500" data-id="element-17" data-mp="10del7sk599wa">
        L’offerta scade tra
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" aria-label={`Offerta valida ancora per ${pad(hours)} ore ${pad(minutes)} minuti ${pad(seconds)} secondi`} data-id="element-18" data-mp="15an3ru97ffy2">
        {units.map(([value, label]) => <div key={label} className="min-w-[68px] flex-1 rounded-xl border border-white/10 bg-ink-900 px-2 py-2 sm:min-w-[84px] sm:flex-none" data-id="element-19" data-mp="17pok5mupa4s8">
            <div className="font-display text-2xl leading-none text-white tabular-nums sm:text-3xl" data-id="element-20" data-mp="f1iz0yzqidrv">
              {value}
            </div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-white/40" data-id="element-21" data-mp="a5c03q5ra2jf">
              {label}
            </div>
          </div>)}
      </div>
    </div>;
}